import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { DataModelService } from '@services/data-model.service';
import { searchObject } from '@app/framework/search-bar/search-bar.component';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-data-search',
  templateUrl: './data-search.component.html',
  styleUrls: ['./data-search.component.scss']
})
export class DataSearchComponent implements OnInit {
  @Output() selectItem = new EventEmitter<any>();
  @Input() data;
  results;
  selected;
  value;
  listSearchOptions = [];
  listSearchTerm;
  listSearchValue;
  listPageNumber = 1;
  listItemsPerPage = 25;
  listTotalNumberOfItems = 0;
  data_check = {};
  _perPage = 10;
  searchData: searchObject;
  set perPage(count) {
    console.log(count);
    this._perPage = count;
  }
  get perPage() {
    return this._perPage;
  }
  itemCount = 0;
  private _active: (number) = 1;
  set active(page: number) {
    console.log(page);
    this._active = page;
    this.getListItems();
  }
  get active(): number {
    return this._active;
  }
  constructor(
    private translationService:TranslationService,
    private courseService: CourseService, private dataModelService: DataModelService) { }


  /*
   *selectedItem: selectedItem,
        currentValue: this.item.value,
        type: this.item.type,
        search_type: this.item.toload_type,
        search_mode: this.item.search_mode || 'list',
        context: context,
        route: this.route,
        allow_multiple: allow_multiple,
        window_title: this.item.search_title && this.item.search_title.length > 0 ? this.item.search_title  : ('Select Items to Link' + (selectedItem.title ? (" to " + selectedItem.title) : "")),
        horizontal_list: this.item.horizontal_list,
        hide_search: this.item.hide_search,
        filter: this.item.filter_search,
        params: { param: this.item.param, req_value: this.item.req_value },
        prevent_create: this.item.prevent_create   *
   * */


  ngOnInit() {
    console.log(this.data)
    this.getListItems();
  }

  addSearchItems(keys) {
    if (keys && keys.length > 0) {
      keys.forEach(key => {
        const searchKey = {
          displayName: (key.json_data && key.json_data.friendlyName) ? key.json_data.friendlyName : key.name,
          value: key.name,
        };
        this.listSearchOptions.push(searchKey)
      })
    }
  }


  isLinked(id, item?) {
    let found = false;
    if (this.data && this.data.selectedItem && this.data.selectedItem.links && this.data.allow_multiple) {
      this.data.selectedItem.links.forEach(link => {
        if (link.linked_id == id) {
          if (item) {
            if (link.id) {
              item.link_id = link.id;
              console.log("LINK SET")
            } else {
              //get id for newly created links that may not have one
              item.links.forEach(l => {
                if (l.linked_id == this.data.selectedItem.id) {
                  item.link_id = l.id
                  console.log("LINK SET")
                }
              })
            }
            item.link_parent = this.data.selectedItem.id;
            item.link_parent_type = this.data.selectedItem.type;

          }
          found = true;
        }
      })
    } else {
      if (id == this.data.currentValue)
        found = true;
    }
    return found;
  }

  /**
   * Generates url to load item for this list
   * */
  generateListUrl(): string {
    let base;
    base = this.data.search_type;
    let url = "";
    if (this.data.context && this.data.context.type && this.data.context.id) {
      url = this.data.context.type + "/" + this.data.context.id + "/" + base
    } else {
      url = "" + base;
    }
    url += `?mode=${(this.data.search_mode || "list")}`;
    return url;
  }

  /**
   *Get a filtered list of item in this list based on any search settting
   * */
  getListItems() {
    let query = "";
    console.log("per page", this._perPage);
    if (this.data.paginate_results) {
      console.log("paginate");
      query += '&pageNumber=' + (this.active - 1);

      if (this._perPage) {
        query += '&perPage=' + this._perPage;
      }
    }
    /*
             filter: this.item.filter_search,
        params: { param: this.item.param, req_value: this.item.req_value },*/
    if (this.data.filter) {
      query += '&searchParam=' + this.data.params.param + '&searchTerm=' + encodeURIComponent(this.data.params.req_value);
    } else {

    if (this.searchData && this.searchData.key != null) {
      query += '&searchParam=' + this.searchData.key + '&searchTerm=' + encodeURIComponent(this.searchData.term);
      }
    }
    if (this.data.context && this.data.context.get_all) {
      query += '&allchildren=true';
    }
    let url = this.generateListUrl();
    this.courseService.get(url + query).subscribe(co => { this.processItems(co) });

  }
  perPageChange(e){
    this.perPage=e;
    this.active = 1;
  }
  search(data: searchObject) {
    this.searchData = data;
    this._active = 1;
    this.getListItems();
  }
  processItems(co, initial?) {
    if (!this.results)
      this.results = []
    if (co && co.totalItems) {
      this.listTotalNumberOfItems = co.totalItems;
    }
    if (co && co.push) {
      co = { listItems: co };
      this.listTotalNumberOfItems = co.length;
    }
    if (co && co.id) {

      co = { listItems: [co] };
      this.listTotalNumberOfItems = 1;
    }
    if (!this.listTotalNumberOfItems) {
      this.listTotalNumberOfItems = co?.listItems?.length||0
    }
    console.log(JSON.stringify(this.results.map(i => { return i.title })));
    /*co.listItems.forEach((v, i) => {
      let pos = this.findInView(v);
      if (pos > -1){
        this.view[pos] = v;
      } else {
        this.view.push(v);
      }
    });*/
    this.results = co.listItems;
    this.results.forEach(i => {
      const linked = this.isLinked(i.id, i) ? true : false;
      if (!this.data_check.hasOwnProperty(i.id)) {
        this.data_check[i.id] = { linked: linked, item: i, link_exists: linked };
      }
    });
    this.itemCount = co.totalItems || co.listItems.length;

  }



  setSelected(item, index) {
    console.log(item);
    if (this.data.allow_multiple) {
      this.data_check[item.id].linked = !this.data_check[item.id].linked;
      this.selectItem.emit(this.toArray(this.data_check));
    } else {
      this.selected = item;
      this.selectItem.emit(item.id);
    }
  }

  checkbox(e) {
    e.stopPropagation();

  }

  toArray(obj) {
    return Object.keys(obj).map(i => obj[i]);
  }

  getCountLabel() {
    if(!this.listTotalNumberOfItems)return ''
    const of = this.translationService.getTranslatedContent('of','of')
    const items = this.translationService.getTranslatedContent('items','Items')
    let start = this.active * this.perPage - this.perPage + 1;
    let end = Math.min(this.active * this.perPage, this.listTotalNumberOfItems);
    return `${start} - ${end} ${of} ${this.listTotalNumberOfItems} ${items}`;

  }

}
